import { Link } from '@routable/gross-ds';
import React from 'react';
import { HELP_DOCS_URL_EXTERNAL } from 'constants/platform';
const HelpDocsLink = ({ className, ...rest }) => {
    return (React.createElement(Link, { className: className, href: HELP_DOCS_URL_EXTERNAL, ...rest, showArrowIcon: false }, "Help docs"));
};
export default HelpDocsLink;
